import React, { useEffect, useState } from "react";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { trackPixel } from "../lib/pixel";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const PaymentSuccess = () => {
  const [state, setState] = useState("checking"); // checking | paid | error
  const [amount, setAmount] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paymentIntent = params.get("payment_intent");
    const sessionId = params.get("session_id");
    if (!paymentIntent && !sessionId) {
      setState("error");
      return;
    }
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const url = paymentIntent
          ? `${BACKEND_URL}/api/payments/intent-status/${paymentIntent}`
          : `${BACKEND_URL}/api/payments/status/${sessionId}`;
        const res = await fetch(url);
        const data = await res.json();
        if (data.payment_status === "paid") {
          setAmount(data.amount);
          setState("paid");
          trackPixel("Purchase", { value: data.amount, currency: "USD" });
          return;
        }
      } catch (e) {}
      if (tries < 8) setTimeout(poll, 2000);
      else setState("error");
    };
    poll();
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-brand-ivory px-5">
      <div className="w-full max-w-md rounded-3xl bg-white p-9 text-center shadow-[0_30px_80px_-35px_rgba(35,35,32,0.35)] ring-1 ring-brand-cream">
        {state === "checking" && (
          <>
            <Loader2 size={40} className="mx-auto animate-spin text-brand-sage" />
            <h1 className="mt-5 font-serif text-2xl text-brand-ink">Confirming your deposit…</h1>
            <p className="mt-2 font-sans text-sm text-brand-muted">One moment while we verify your payment.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-brand-sage/10">
              <CheckCircle2 size={32} className="text-brand-sage" />
            </div>
            <h1 className="mt-5 font-serif text-3xl text-brand-ink">You're all booked!</h1>
            <p className="mt-3 font-sans text-sm text-brand-muted">
              Your refundable ${amount} deposit is confirmed and your spot is secured. We'll see you soon —
              check your email &amp; texts for the appointment details.
            </p>
            <a href="/" className="mt-7 inline-flex rounded-full bg-brand-sage px-8 py-3.5 font-sans text-sm font-semibold uppercase tracking-[0.14em] text-brand-ivory transition hover:bg-brand-sagedark">Done</a>
          </>
        )}
        {state === "error" && (
          <>
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-brand-cream">
              <XCircle size={32} className="text-brand-golddark" />
            </div>
            <h1 className="mt-5 font-serif text-2xl text-brand-ink">We couldn't confirm your payment yet</h1>
            <p className="mt-2 font-sans text-sm text-brand-muted">
              If you were charged, your spot is safe — we'll reach out to confirm. Otherwise please try again.
            </p>
          </>
        )}
      </div>
    </div>
  );
};
